import { cn } from "@faire/prototype-playground/lib/utils";

function ChevronIcon({ expanded }: { expanded?: boolean }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={cn("transition-transform", expanded ? "rotate-90" : "")}
    >
      <path
        d="M6 4L10 8L6 12"
        stroke="#757575"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Brand portal sidebar shell matched to production Ads Manager navigation. */
export const BrandSidebar = () => {
  return (
    <div className="bg-fs-surface-primary sticky top-0 flex h-screen w-64 shrink-0 flex-col border-r border-[#dfe0e1]">
      <div className="flex items-center justify-between px-6 py-8">
        <img src="/images/faire-logo.svg" alt="Faire" className="w-[88px]" />
        <div className="flex items-center gap-2">
          <button
            type="button"
            className="relative flex h-10 w-10 items-center justify-center rounded-full hover:bg-[#f7f7f7]"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#333"
              strokeWidth="1.5"
            >
              <path
                d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.73 21a2 2 0 0 1-3.46 0"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="absolute top-2 right-2 h-2 w-2 rounded-full bg-[#E53935]" />
          </button>
          <button
            type="button"
            className="flex h-10 w-10 items-center justify-center rounded-full bg-[#E8D5C4] text-sm font-medium text-[#333]"
          >
            AC
          </button>
        </div>
      </div>
      <nav className="flex flex-1 flex-col gap-1 overflow-auto">
        <span className="px-6 py-1.5 text-sm text-[#333]">Home</span>
        <span className="flex items-center justify-between px-6 py-1.5 text-sm text-[#333]">
          <span>Orders</span>
          <div className="flex items-center gap-2">
            <span className="text-fs-text-primary-inverse rounded-full bg-[#333] px-2 text-xs">
              1
            </span>
            <ChevronIcon />
          </div>
        </span>
        <span className="px-6 py-1.5 text-sm text-[#333]">Messages</span>
        <span className="flex items-center justify-between px-6 py-1.5 text-sm text-[#333]">
          <span>Products</span>
          <ChevronIcon />
        </span>
        <span className="flex items-center justify-between px-6 py-1.5 text-sm text-[#333]">
          <span>Customers</span>
          <ChevronIcon />
        </span>
        <span className="flex items-center justify-between px-6 py-1.5 text-sm text-[#333]">
          <span>Faire Direct</span>
          <ChevronIcon />
        </span>
        <span className="flex items-center justify-between px-6 py-1.5 text-sm text-[#333]">
          <span>Marketing</span>
          <ChevronIcon expanded />
        </span>
        <span className="py-1.5 pr-6 pl-10 text-sm text-[#333]">Campaigns</span>
        <span className="py-1.5 pr-6 pl-10 text-sm text-[#333]">
          Automations
        </span>
        <span className="py-1.5 pr-6 pl-10 text-sm text-[#333]">
          Promotions
        </span>
        <div className="relative mx-2">
          <div className="absolute inset-0 rounded-lg bg-[#f7f7f7]" />
          <span className="relative flex items-center justify-between py-1.5 pr-6 pl-8 text-sm font-medium text-[#333]">
            <span>Promoted Listings</span>
            <span className="rounded-sm border border-[#333] px-1.5 py-0.5 text-[11px] text-[#333]">
              New
            </span>
          </span>
        </div>
        <span className="py-1.5 pr-6 pl-10 text-sm text-[#333]">
          Insider Partnership
        </span>
        <span className="py-1.5 pr-6 pl-10 text-sm text-[#333]">Events</span>
        <span className="flex items-center justify-between px-6 py-1.5 text-sm text-[#333]">
          <span>Analytics</span>
          <ChevronIcon />
        </span>
        <span className="flex items-center justify-between px-6 py-1.5 text-sm text-[#333]">
          <span>My shop</span>
          <ChevronIcon />
        </span>
        <span className="flex items-center justify-between px-6 py-1.5 text-sm text-[#333]">
          <span>Settings</span>
          <ChevronIcon />
        </span>
      </nav>
      <div className="border-t border-[#dfe0e1] py-4">
        <span className="block px-6 py-1.5 text-sm text-[#333]">
          Help Center
        </span>
        <span className="block px-6 py-1.5 text-sm text-[#333]">
          What&apos;s new
        </span>
      </div>
    </div>
  );
};
